import React, { useRef, useEffect } from 'react';

const ClickSpark = ({
  children,
  sparkColor = '#D4AF37',
  sparkSize = 10,
  sparkCount = 8,
  duration = 400,
  easing = 'ease-out',
  extraScale = 1.0
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleClick = (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      for (let i = 0; i < sparkCount; i++) {
        createSpark(x, y);
      }
    };

    const createSpark = (x, y) => {
      const spark = document.createElement('div');
      spark.style.position = 'absolute';
      spark.style.left = `${x}px`;
      spark.style.top = `${y}px`;
      spark.style.width = `${sparkSize}px`;
      spark.style.height = `${sparkSize}px`;
      spark.style.backgroundColor = sparkColor;
      spark.style.borderRadius = '50%';
      spark.style.pointerEvents = 'none';
      spark.style.zIndex = '10000';
      spark.style.boxShadow = `0 0 ${sparkSize}px ${sparkColor}`;

      const angle = Math.random() * Math.PI * 2;
      const distance = Math.random() * 100 * extraScale;
      const destinationX = Math.cos(angle) * distance;
      const destinationY = Math.sin(angle) * distance;

      container.appendChild(spark);

      const animation = spark.animate(
        [
          { transform: 'translate(0, 0) scale(1)', opacity: 1 },
          { transform: `translate(${destinationX}px, ${destinationY}px) scale(0)`, opacity: 0 }
        ],
        {
          duration: duration,
          easing: easing
        }
      );

      animation.onfinish = () => spark.remove();
    };

    container.addEventListener('click', handleClick);
    return () => container.removeEventListener('click', handleClick);
  }, [sparkColor, sparkSize, sparkCount, duration, easing, extraScale]);

  return (
    <div ref={containerRef} style={{ position: 'relative', width: '100%', height: '100%' }}>
      {children}
    </div>
  );
};

export default ClickSpark;



